/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionCompanyMutation($input: SaveSouscriptionCompany_M_souscription_companyInput!) {
    saveSouscriptionCompany_M_souscription_company(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
